import makeStyles from '@mui/styles/makeStyles';
import { IconButton, Stack, Pagination, Popover, Slider } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activeViewerWindow, setZoomPage, setActivePage, setToolbarSubData, setPageRotate } from './store/documentViewerReducer';
import {
    MultiLayers,
    FullScreen,
    Magnifier,
    RotateRight,
    Expand,
    Comments,
    SplitView,
    PageBookmark,
    ImageQuality,
    Printer,
    StarOutline,
    PageMagnifier,
    HistoryClock,
    EmergencyInfo,
    MetadataInfo,
} from './assets/icons';
import { ZOOM_MAXIMUM, ZOOM_MINIMUM, ZOOM_STEP } from './store/constans';

const useStyles = makeStyles((theme) => ({
    root: {
        '& ::-webkit-scrollbar-thumb:hover': {
            background: `${theme.palette.documentViewer.lowContrastTextHoverColor} !important`,
        },
        '& ::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
        '& ::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
        },
        '& ::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.documentViewer.lowContrastTextColor,
        },
    },
    buttonsToolbar: {
        overflowY: 'auto',
    },
    pagination: {
        maxHeight: '241px',
    },
    centeredPagination: {
        '& ul': {
            justifyContent: 'center',
            '& li .Mui-selected': {
                borderWidth: '0.5px',
                borderStyle: 'solid',
                borderColor: theme.palette.fieldsetBorderColor.primary,
                backgroundColor: theme.palette.documentViewer.pageSelectedBackgroundColor,
                fontWeight: 600,
                borderRadius: '12px',
                height: '28px',
                lineHeight: '27px',
            },
        },
    },
    toolbarButton: {
        borderRadius: '2px',
        paddingTop: '12px',
        paddingBottom: '12px',
        '&.contained': {
            backgroundColor: theme.palette.primary.main,
        },
    },
}));

export function ViewerToolbar(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const paginatorRef = React.useRef();
    const [buttonToolbarMaxHeight, setButtonToolbarMaxHeight] = React.useState('calc(100% - 242px)');
    //TODO: change it to something get from toolbar (after it changes)
    const activeViewerWindowIdx = useSelector(activeViewerWindow);
    const activeTab = props.selectedTabs[activeViewerWindowIdx];

    const activePage = useSelector((state) =>
        state.documentViewer.currentToolbarSet !== null ? state.documentViewer.currentToolbarSet.activePage : 0,
    );
    const setActivePageToReducer = (newActivePage) => {
        dispatch(setActivePage({ page: newActivePage }));
    };
    const pageCount = useSelector((state) =>
        state.documentViewer.currentToolbarSet !== null ? state.documentViewer.currentToolbarSet.pageCount : 0,
    );
    const zoom = useSelector((state) =>
        state.documentViewer.currentDocPageSet !== null ? state.documentViewer.currentDocPageSet.zoom : 0,
    );
    const setScaleToReducer = (_event, newZoom) => {
        dispatch(setZoomPage({ zoom: newZoom }));
    };
    const rotation = useSelector((state) =>
        state.documentViewer.currentDocPageSet !== null ? state.documentViewer.currentDocPageSet.rotation : 0,
    );
    const setRotateToReducer = (_event, newRotate) => {
        dispatch(setPageRotate({ rotate: newRotate }));
    };
    const subData = useSelector((state) =>
        state.documentViewer.currentToolbarSet !== null ? state.documentViewer.currentToolbarSet.wideViewSubData : '',
    );

    const [anchorToolbarEl, setAnchorToolbarEl] = useState(null);
    const [popoverContent, setPopoverContent] = useState(null);
    const openToolbarPopover = Boolean(anchorToolbarEl);
    const handleClose = () => {
        setAnchorToolbarEl(null);
    };
    const handleOpenPopover = (event) => {
        setAnchorToolbarEl(event.currentTarget);
    };

    const openSubDataAdditionalPanel = (inputSubData) => {
        if (inputSubData === subData) {
            dispatch(setToolbarSubData({ subData: '' }));
        } else {
            dispatch(setToolbarSubData({ subData: inputSubData }));
        }
    };

    React.useEffect(() => {
        if (paginatorRef.current) {
            const paginatorHeight = _.get(paginatorRef, 'current.clientHeight', 1);
            setButtonToolbarMaxHeight(`calc(100% - ${paginatorHeight}px)`);
        }
    }, [paginatorRef]);

    return (
        <>
            <Stack direction={'column'} height={'100%'} justifyContent={'space-between'} width={'50px'} className={classes.root}>
                {activeTab && activeTab !== -1 && (
                    <Stack className={classes.buttonsToolbar} maxHeight={buttonToolbarMaxHeight}>
                        <IconButton
                            className={`${classes.toolbarButton} ${subData === 'pages' ? 'contained' : ''}`}
                            onClick={() => openSubDataAdditionalPanel('pages')}
                            size="medium"
                        >
                            <MultiLayers />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <FullScreen />
                        </IconButton>
                        <IconButton
                            className={classes.toolbarButton}
                            size="medium"
                            onClick={(event) => {
                                setPopoverContent('zoom'); //TODO: change to some enum maybe?
                                handleOpenPopover(event);
                            }}
                        >
                            <Magnifier />
                        </IconButton>

                        <IconButton
                            className={classes.toolbarButton}
                            onClick={(event) => {
                                setPopoverContent('rotate');
                                handleOpenPopover(event);
                            }}
                            size="medium"
                        >
                            <RotateRight />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <SplitView />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <Expand />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <Comments />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <PageBookmark />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <ImageQuality />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <Printer />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <StarOutline />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <PageMagnifier />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <HistoryClock />
                        </IconButton>
                        <IconButton className={classes.toolbarButton} size="medium">
                            <EmergencyInfo />
                        </IconButton>
                        <IconButton
                            className={`${classes.toolbarButton} ${subData === 'metadata' ? 'contained' : ''}`}
                            size="medium"
                            onClick={() => openSubDataAdditionalPanel('metadata')}
                        >
                            <MetadataInfo />
                        </IconButton>
                    </Stack>
                )}
                {activePage > 0 && pageCount > 0 && (
                    <Stack maxHeight={241} className={classes.pagination} ref={paginatorRef}>
                        <IconButton
                            className={classes.toolbarButton}
                            disabled={activePage === 1}
                            size="medium"
                            onClick={() => {
                                setActivePageToReducer(activePage - 1);
                            }}
                        >
                            <ExpandLessIcon />
                        </IconButton>
                        <Pagination
                            count={pageCount}
                            className={classes.centeredPagination}
                            page={activePage}
                            boundaryCount={0}
                            siblingCount={1}
                            size={'medium'}
                            hideNextButton={true}
                            hidePrevButton={true}
                            onChange={(_event, newActivePage) => {
                                setActivePageToReducer(newActivePage);
                            }}
                        />
                        <IconButton
                            className={classes.toolbarButton}
                            disabled={activePage >= pageCount}
                            size="medium"
                            onClick={() => {
                                setActivePageToReducer(activePage + 1);
                            }}
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                    </Stack>
                )}
            </Stack>
            <Popover
                id="toolbar-popover"
                open={openToolbarPopover}
                anchorEl={anchorToolbarEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {popoverContent === 'zoom' && (
                    <Stack width={280} direction={'row'} alignItems={'center'} style={{ overflow: 'hidden' }} height={48}>
                        <IconButton
                            size={'18px'}
                            onClick={(ev) => {
                                setScaleToReducer(ev, zoom - ZOOM_STEP);
                            }}
                        >
                            <ZoomOutIcon />
                        </IconButton>
                        <Slider
                            aria-label="Scale"
                            value={zoom}
                            onChange={setScaleToReducer}
                            step={ZOOM_STEP}
                            min={ZOOM_MINIMUM}
                            max={ZOOM_MAXIMUM}
                            disabled={activeTab === -1 && zoom > 0}
                        />
                        <IconButton
                            size={'18px'}
                            onClick={(ev) => {
                                setScaleToReducer(ev, zoom + ZOOM_STEP);
                            }}
                        >
                            <ZoomInIcon />
                        </IconButton>
                    </Stack>
                )}
                {popoverContent === 'rotate' && (
                    <Stack width={280} direction={'row'} alignItems={'center'} style={{ overflow: 'hidden' }} height={48}>
                        <IconButton
                            style={{ marginRight: '10px' }}
                            size={'18px'}
                            onClick={(ev) => {
                                if (rotation - 5 < 0) {
                                    setRotateToReducer(ev, 360 - rotation - 5);
                                } else {
                                    setRotateToReducer(ev, rotation - 5);
                                }
                            }}
                        >
                            <RotateRight style={{ transform: 'scale(-1, 1)' }} />
                        </IconButton>
                        <Slider
                            aria-label="Rotation"
                            value={rotation}
                            onChange={setRotateToReducer}
                            step={1}
                            min={0}
                            max={359}
                            disabled={activeTab === -1}
                        />
                        <IconButton
                            size={'18px'}
                            onClick={(ev) => {
                                if (rotation >= 0 && rotation < 90) setRotateToReducer(ev, 90);
                                else {
                                    if (rotation >= 90 && rotation < 180) setRotateToReducer(ev, 180);
                                    else {
                                        if (rotation >= 180 && rotation < 270) setRotateToReducer(ev, 270);
                                        else {
                                            setRotateToReducer(ev, 0);
                                        }
                                    }
                                }
                            }}
                        >
                            <RotateRight />
                        </IconButton>
                    </Stack>
                )}
            </Popover>
        </>
    );
}
